import React, { useState, useEffect } from 'react';

import { Link, useNavigate, useLocation } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

import PublicShell from '../components/PublicShell';



const Login = () => {

  const [form, setForm] = useState({ username: '', password: '' });

  const [error, setError] = useState('');

  const [loading, setLoading] = useState(false);

  const { login, isAuthenticated } = useAuth();

  const navigate = useNavigate();

  const location = useLocation();

  const successMessage = location.state?.message;



  useEffect(() => {

    if (isAuthenticated) {

      const from = location.state?.from?.pathname || '/uebersicht';

      navigate(from, { replace: true });

    }

  }, [isAuthenticated, navigate, location.state]);



  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    setError('');

    const result = await login(form.username, form.password);

    if (result.success) {

      const from = location.state?.from?.pathname || '/uebersicht';

      navigate(from, { replace: true });

    } else {

      setError(result.error);

    }

    setLoading(false);

  };



  return (

    <PublicShell narrow>

      <div className="auth-card">

        <span className="t12-badge">Tippspiel</span>

        <h1 className="section-title text-2xl md:text-3xl mb-1">Anmelden</h1>

        <p className="text-sm text-white/50 mb-6">

          Melde dich an, um Tipps abzugeben und die Rangliste zu sehen.

        </p>

        {successMessage && <div className="alert-success-dark mb-4">{successMessage}</div>}

        {error && <div className="alert-error-dark mb-4">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">

          <div>

            <label className="label-dark" htmlFor="username">Benutzername</label>

            <input

              id="username"

              className="input-dark"

              value={form.username}

              onChange={(e) => setForm({ ...form, username: e.target.value })}

              required

            />

          </div>

          <div>

            <label className="label-dark" htmlFor="password">Passwort</label>

            <input

              id="password"

              type="password"

              className="input-dark"

              value={form.password}

              onChange={(e) => setForm({ ...form, password: e.target.value })}

              required

            />

          </div>

          <button type="submit" className="btn-wacker w-full" disabled={loading}>

            {loading ? 'Anmelden…' : 'Anmelden'}

          </button>

        </form>

        <p className="text-center text-sm mt-6 text-white/50">

          Noch kein Konto?{' '}

          <Link to="/register" className="text-primary-light hover:underline font-semibold">Registrieren</Link>

        </p>

        <p className="text-center text-sm mt-2">

          <Link to="/" className="text-white/40 hover:text-white/70 text-xs">← Zur Startseite</Link>

        </p>

      </div>

    </PublicShell>

  );

};



export default Login;


